import { render, staticRenderFns } from "./CompleteEyesWanted.vue?vue&type=template&id=770c3a0b&scoped=true&"
import script from "./CompleteEyesWanted.vue?vue&type=script&lang=js&"
export * from "./CompleteEyesWanted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c3a0b",
  null
  
)

export default component.exports